import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Platform, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';
import { IconLink, theme } from '@sg/garnish';

export const SierraHeader = (props: SierraHeaderProps) => {
  const { onClose } = props;
  const { formatMessage } = useIntl();

  const { top } = useSafeAreaInsets();
  const topPosition = useStyle(
    () => ({
      top: Platform.select({
        android: top + theme.spacing['4'],
        default: theme.spacing['4'],
      }),
    }),
    [top],
  );

  return (
    <View style={[styles.header, topPosition]}>
      <IconLink
        name="IconClose"
        accessibilityLabel={formatMessage(messages.close)}
        width={24}
        height={24}
        onPress={onClose}
      />
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  close: {
    defaultMessage: 'Close Chat',
    description: 'Sierra | Chat | Close',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  header: {
    position: 'absolute',
    right: theme.spacing['4'],
    zIndex: theme.zIndex.tooltip,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type SierraHeaderProps = {
  onClose: () => void;
};
